import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    TextField,
    Box
} from "@mui/material";
import { useState } from "react";

export default function MPTubeRoomTempTable({ rows, onSearchChange, searchValue: searchValueProp }) {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState(searchValueProp ?? "");

    const handleChangePage = (_, newPage) => setPage(newPage);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);
        if (onSearchChange) onSearchChange(value);
    };

    const thicknessRanges = [
        { label: "T ≤ 16", key: "t_le_16" },
        { label: "16 < T ≤ 40", key: "t_16_40" },
        { label: "40 < T ≤ 60", key: "t_40_60" },
        { label: "60 < T ≤ 100", key: "t_60_100" },
    ];

    const mpaArray = ["MPa", "MPa", "MPa", "MPa", "MPa"];

    const paginatedRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const SEARCH_FIELD_SX = {
        width: 250,
        "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            transition: "all 0.2s ease-in-out",

            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--text-primary)",
            },

            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--color-primary)",
                borderWidth: "2px",
            },
        },

        "& .MuiInputBase-input": {
            color: "var(--text-primary)",
        },

        "& .MuiInputLabel-root.Mui-focused": {
            color: "var(--text-primary)",
        },
    };


    return (
        <Paper sx={{ p: 2, overflow: "auto" }}>

            <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end" }}>
                <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Procurar..."
                    value={searchValue}
                    onChange={handleSearchChange}
                    sx={SEARCH_FIELD_SX}
                />
            </Box>


            <Table sx={{ borderCollapse: "collapse" }}>

                <TableHead>

                    <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold" } }}>
                        <TableCell colSpan={2} rowSpan={2}>Steel grade</TableCell>
                        <TableCell colSpan={6}>Tensile properties at room temperature</TableCell>
                        <TableCell colSpan={9}>Impact properties a b</TableCell>
                    </TableRow>

                    <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold" } }}>
                        <TableCell colSpan={4}>Upper yield strength or proof strength
                            Ren or Rpo,2 for wall thickness T min.</TableCell>
                        <TableCell rowSpan={2}>Tensile strengthRm</TableCell>
                        <TableCell colSpan={2} rowSpan={2}>Elongation $A$ min. %</TableCell>
                        <TableCell colSpan={8}>Minimum average absorbed energy KVz
                            at a temperature of
                            °C</TableCell>
                    </TableRow>

                    <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold" } }}>
                        <TableCell rowSpan={2}>Steel name</TableCell>
                        <TableCell rowSpan={2}>Steel number</TableCell>
                        {thicknessRanges.map(row => (
                            <TableCell key={row.key}>{row.label}</TableCell>
                        ))}
                        <TableCell colSpan={3}>l</TableCell>
                        <TableCell colSpan={2}> t</TableCell>
                    </TableRow>
                    <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold" } }}>
                        {mpaArray.map((row, index) => (
                            <TableCell key={index}>{row}</TableCell>
                        ))}
                        <TableCell>l</TableCell>
                        <TableCell>t</TableCell>
                        <TableCell>20</TableCell>
                        <TableCell>0</TableCell>
                        <TableCell>-10</TableCell>
                        <TableCell>20</TableCell>
                        <TableCell>0</TableCell>
                    </TableRow>

                </TableHead>
                <TableBody>
                    {paginatedRows.map((row, rowIndex) => {
                        const p = row.properties;

                        return (
                            <TableRow key={row.id || rowIndex} sx={{ "& td": { border: "1px solid var(--border-color)", textAlign: "center" } }}>

                                <TableCell>{row.steelName}</TableCell>
                                <TableCell>{row.steelNumber}</TableCell>

                                <TableCell>{p.yieldStrengthMpaMinTLe16 ?? "–"}</TableCell>
                                <TableCell>{p.yieldStrengthMpaMinT16To40 ?? "–"}</TableCell>
                                <TableCell>{p.yieldStrengthMpaMinT40To60 ?? "–"}</TableCell>
                                <TableCell>{p.yieldStrengthMpaMinT60To100 ?? "–"}</TableCell>

                                <TableCell>{p.tensileStrengthRmMpa ?? "–"}</TableCell>

                                <TableCell>{p.elongationAMinPercTLt3mm ?? "–"}</TableCell>
                                <TableCell>{p.elongationAMinPercTGt3mm ?? "–"}</TableCell>

                                <TableCell>{p.impactEnergy20CJMin1 ?? "–"}</TableCell>
                                <TableCell>{p.impactEnergy0CJMin ?? "–"}</TableCell>
                                <TableCell>{p.impactEnergyNeg10CJMin1 ?? "–"}</TableCell>

                                <TableCell>{p.impactEnergy20CJMin2 ?? "–"}</TableCell>
                                <TableCell>{p.impactEnergyNeg0CJMin2 ?? "–"}</TableCell>

                            </TableRow>
                        );
                    })}
                </TableBody>

            </Table>

            <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[10, 25, 50]}
            />

        </Paper>
    );
}